"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductKey = exports.PlanKey = exports.PlanName = exports.ProductFamily = void 0;
var ProductFamily;
(function (ProductFamily) {
    ProductFamily["ShareFile"] = "ShareFile";
    ProductFamily["RightSignature"] = "RightSignature";
    ProductFamily["Podio"] = "Podio";
    ProductFamily["AddOn"] = "Add-On";
    ProductFamily["Support"] = "Support";
})(ProductFamily || (exports.ProductFamily = ProductFamily = {}));
var PlanName;
(function (PlanName) {
    PlanName["STANDARD"] = "Standard";
    PlanName["STANDARD0GB"] = "Standard 0 GB";
    PlanName["ADVANCED"] = "Advanced";
    PlanName["ADVANCED0GB"] = "Advanced 0 GB";
    PlanName["PREMIUM"] = "Premium";
    PlanName["INDUSTRY_ADVANTAGE"] = "Industry Advantage";
    PlanName["VDR"] = "VDR";
})(PlanName || (exports.PlanName = PlanName = {}));
var PlanKey;
(function (PlanKey) {
    PlanKey["STANDARD"] = "Standard";
    PlanKey["ADVANCED"] = "Advanced";
    PlanKey["ADVANCED_KBA"] = "Advanced KBA";
    PlanKey["PREMIUM"] = "Premium";
    PlanKey["PREMIUM_S"] = "Premium S";
    PlanKey["INDUSTRY_ADVANTAGE"] = "Industry Advantage";
    PlanKey["VDR"] = "VDR";
    PlanKey["BASIC"] = "Basic";
    PlanKey["BUSINESS"] = "Business";
    PlanKey["TEAM"] = "Team";
    PlanKey["PLUS"] = "Plus";
    PlanKey["KBA"] = "KBA";
    PlanKey["ADVANCED0GB"] = "Advanced 0GB";
    PlanKey["STANDARD0GB"] = "Standard 0GB";
    PlanKey["CONNECTORS"] = "Connectors 0GB";
    PlanKey["SF3TB"] = "3TB Storage Pack";
    PlanKey["SF500GB"] = "500GB Storage Pack";
})(PlanKey || (exports.PlanKey = PlanKey = {}));
var ProductKey;
(function (ProductKey) {
    ProductKey["ShareFile"] = "ShareFile";
    ProductKey["RightSignature"] = "RightSignature";
    ProductKey["Podio"] = "Podio";
    ProductKey["Storage"] = "Storage";
})(ProductKey || (exports.ProductKey = ProductKey = {}));
//# sourceMappingURL=common.js.map